export default __webpack_public_path__ + "static/media/ic-cancelbtn-gray-24-px.4e371854.svg";